module.exports = __webpack_public_path__ + "fontawesome-webfont.4b5a84aaf1c9485e060c.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/thiago/Documents/projetos/biblioteco-angular/src/assets/global/plugins/font-awesome/fonts/fontawesome-webfont.woff2?v=4.4.0
// module id = ../../../../../src/assets/global/plugins/font-awesome/fonts/fontawesome-webfont.woff2?v=4.4.0
// module chunks = styles